import React, { useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, cn, makeStyles } from '@cicero/ui'
import { DefaultCellRenderer, EditableCell } from 'forms/cells'
import { IEditorElementProps, IElementDefinition } from '../EditorService'
import { ISpreadsheetElement, SpreadsheetCommands } from '../commands'

export const SpreadsheetElement = ({ children, attributes }: IEditorElementProps<ISpreadsheetElement>) => {
  const { spreadsheetWrapper, headerCell } = useStyles()
  const [activeCell, setActiveCell] = useState('')
  const [rows, setRows] = useState([
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','Hello','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
    ['','','','','','','','','','','','',''],
  ])

  const updateCell = (row: number, col: number, val: any) => {
    const changedRow = rows[row]
    changedRow[col] = val
    setRows([
      ...rows.slice(0, row),
      [...changedRow],
      ...rows.slice(row + 1, rows.length),
    ])
  }

  return <div
    className={cn(spreadsheetWrapper)}
    contentEditable={false}
    {...attributes}
  >
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={headerCell}></TableCell>
          { rows[0].map((row, i) => <TableCell key={i} className={headerCell}>{SpreadsheetCommands.getColumnId(i+1)}</TableCell>) }
        </TableRow>
      </TableHead>
      <TableBody>
        {
          rows.map((row, i) =>
            <TableRow key={i}>
              <TableCell className={headerCell}>{i + 1}</TableCell>
              { row.map((cell, j) => {
                const cellId = `${i}:${j}`
                return <EditableCell
                  key={j}
                  type={DefaultCellRenderer}
                  value={cell}
                  setValue={(v) => updateCell(i, j, v)}
                  editing={activeCell === cellId}
                  setEditing={(active) => setActiveCell(active ? cellId : '')}
                />
              })}
            </TableRow>
          )
        }
      </TableBody>
    </Table>
    {children}
  </div>
}

export const SpreadsheetElementDef: IElementDefinition = {
  renderer(props) { return <SpreadsheetElement {...props} /> },
  setup(service) {
    const { isVoid } = service.editor
    service.editor.isVoid = (el) => el.type === 'spreadsheet' ? true : isVoid(el)
  },
}

const useStyles = makeStyles({
  spreadsheetWrapper: {
    padding: 0,
    boxSizing: 'border-box',
    flexWrap: 'wrap',
    margin: '6px',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    display: 'flex',
    '& > *': {
      flexGrow: 1,
    },

    '& td': {
      borderRight: '1px solid #AAA',
      padding: 6,
    },
  },
  headerCell: {
    background: '#EBEBEB',
    textAlign: 'center',
    '&:first-of-type': {
      width: 60,
    },
  },
})
